import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";
import InterfaceProperties from "../../../components/Interface/InterfaceProperties";
import InterfaceCompatibility from "../../../components/Interface/InterfaceCompatibility";

class Component_information_paragraph extends PureComponent {
  render() {
    return (
      <div className="row" id="component_information_paragraph">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Information Paragraph</h2>
              <p>
                Information Paragraphs are a simple way of adding text to a
                record, dashboard, report, or search page. Information paragraph
                supports colors and "hide_if_eval" eval methods.
              </p>

              <InterfaceCompatibility
                dashboard={true}
                record={true}
                report={true}
                search={true}
              />
              <InterfaceProperties
                type={"information_paragraph"}
                name={"paragraph"}
                padding={true}
                hide={true}
                order={true}
                properties={[
                  {
                    property: "paragraph_color",
                    description: "Set the color of the text.",
                    defaults:
                      '"#F44336", "#388E3C" default is "RGBA(0, 0, 0, 0.87)"'
                  },
                  {
                    property: "text",
                    description:
                      "Text that will be displayed inside the heading.",
                    defaults: '"My heading text here"'
                  }
                ]}
              />
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Information Paragraph Example</h2>
            </section>
            <section>
              <h3>Example 1: Simple Paragraph</h3>
              <div className="darkCode">
                <div>&#123;</div>
                <strong>
                  <div className="i1">
                    <span className="jsonG">"type"</span>:{" "}
                    <span className="jsonY">"information_paragraph"</span>,
                  </div>
                </strong>
                <div className="i1">
                  <span className="jsonG">"paragraph_color"</span>:{" "}
                  <span className="jsonY">"#F44336"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"text"</span>:{" "}
                  <span className="jsonY">
                    "This is some text in my first paragraph."
                  </span>
                  ,
                </div>
                <div className="i1">
                  <span className="jsonG">"order"</span>:{" "}
                  <span className="jsonP">1</span>
                </div>
                <div>&#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Component_information_paragraph;



// WEBPACK FOOTER //
// ./src/components/knowlege/interface/Component_information_paragraph.js